import { CategoriaNode } from '@gql/graphql'
import { ParsedUrlQuery } from 'querystring'
import { FilterValueType } from 'utils/types'

export const PAGINATION_ITEM_PER_PAGE = 12
export const PAGINATION_PROGETTI_PER_PAGE = 6

export const CHIAVI_ATTRIBUTI_FILTERS = [
  'brand',
  'novita_exact',
  'made_usa_exact',
  'quickship_exact',
  'effetto',
  'ambiente',
  'colore',
  'macroformato',
  'formato',
  'spessore',
  'scivolosita',
  'macrosuperficie',
  'tipologia',
  'destinazioneuso',
  'soluzione',
  'award',
]

export const getOrdinamento = (listing: any) => {
  if (listing && listing?.ordinamenti && listing.ordinamenti.length > 0) {
    if (listing?.params && listing.params.ordinamento) {
      return listing.params.ordinamento.value
    }
    return listing.ordinamenti[0].value
  }
  return null
}

export const getFilters = (listing: any): FilterValueType[] => {
  const elems = []
  if (listing?.attributi && listing.params?.filtri?.length > 0) {
    listing.params.filtri.forEach((f) => {
      const attributo = listing.attributi.find((a) => a.chiave === f.chiave)
      if (attributo && f?.valori && f.valori.length > 0) {
        f.valori.forEach((fv) => {
          const attributoValore = attributo.valori.find((v) => v.id === fv.id)
          if (attributoValore) {
            elems.push({
              id: attributoValore.id,
              label: attributoValore.label,
              chiave: f.chiave,
            })

            if (attributoValore?.valori) {
              const attributoValoreValori = attributoValore?.valori.filter((av) =>
                f.valori.find((fv) => fv.id === av.id)
              )
              if (attributoValoreValori.length) {
                attributoValoreValori.forEach((avv) => {
                  elems.push({
                    id: avv.id,
                    label: avv.label,
                    chiave: avv.chiave,
                  })
                })
              }
            }
          }
        })
      }
    })
  }
  return elems
}

export const fromFiltersToUrl = (filters: FilterValueType[]) => {
  const filtersGrouped = Object.groupBy(filters, ({ chiave }) => chiave)

  return Object.keys(filtersGrouped).map((filterKey) => ({
    k: filterKey,
    v: filtersGrouped[filterKey].map((elem) => elem.id).join(),
  }))
}

export const fromParsedUrlToParams = (
  parsedUrlQuery: ParsedUrlQuery,
  isProgetti: boolean = false,
  categoria: CategoriaNode = null
): any => {
  const elems = []
  Object.keys(parsedUrlQuery).forEach((k) => {
    if (k === 'order' || k === 'page' || k === 'search' || (k === 'slug' && !categoria)) {
      return null
    }
    if (k === 'slug' && parsedUrlQuery[k].length > 1 && categoria) {
      elems.push({
        chiave: categoria.macrocategoria.chiaveRicerca,
        valori: [{ id: categoria.objectId }],
      })
    } else {
      const elem = parsedUrlQuery[k]
      const ids = typeof elem === 'string' ? elem.split(',') : [elem]
      if (ids.length > 0 && CHIAVI_ATTRIBUTI_FILTERS.includes(k)) {
        elems.push({
          chiave: k,
          valori: ids.map((id: any) => ({ id: parseInt(id) })),
        })
      }
    }
  })

  const ordinamentoDefault = isProgetti ? 'ordinamento_web' : '-ordinamento'

  const result = {
    search: parsedUrlQuery['search'] || null,
    page: parsedUrlQuery['page'] ? parseInt(parsedUrlQuery['page'].toString()) : 1,
    filtri: elems,
    ordinamento: {
      value: parsedUrlQuery['order'] || ordinamentoDefault,
    },
  }

  //console.log(JSON.stringify(result, null, 2))

  return result
}
